
// const apiURL = 'http://localhost:4000/api/';
const apiURL = 'https://api.jwlbook.com/api/';


export const Constants = {

  // imageBaseURL: 'http://localhost:4000/uploads/',
  imageBaseURL: 'https://api.jwlbook.com/uploads/',

  userRegister: apiURL + 'user/register',
  userLogin: apiURL + 'user/login',
  editRegister: apiURL + 'user/update',
  userInfoById: apiURL + 'user/user-info',
  userExitEmail: apiURL + 'user/check-email',
  changedPassword: apiURL + 'user/change-password',
  addContact: apiURL + 'user/contact',

  listCounty: apiURL + 'location/list-country',
  getCountryById: apiURL + 'location/get-country',
  listState: apiURL + 'location/list-state',
  getStatecountryById: apiURL + 'location/get-state-country',
  listCity: apiURL + 'location/list-city',
  getCityStateById: apiURL + 'location/get-city-state',

  listSelection: apiURL + 'product/list-main-selection',
  addSelection: apiURL + 'product/add-main-selection',
  editSelection: apiURL + 'product/update-main-selection',
  getSelectionById: apiURL + 'product/get-main-selection',
  deleteSelection: apiURL + 'product/main-selection',

  listCategory: apiURL + 'product/list-category',
  getCategoryById: apiURL + 'product/get-category',
  addCategory: apiURL + 'product/add-category',
  editCategory: apiURL + 'product/update-category',
  deleteCategory: apiURL + 'product/category',

  listShopFor: apiURL + 'product/list-shopfor',
  getShopForById: apiURL + 'product/shopfor',
  addShopFor: apiURL + 'product/add-shopfor',
  editShopFor: apiURL + 'product/update-shopfor',
  deleteShopFor: apiURL + 'product/shopfor',

  listRingStyle: apiURL + 'product/list-ringstyle',
  getRingStyleById: apiURL + 'product/ringstyle',
  addRingStyle: apiURL + 'product/add-ringstyle',
  editRingStyle: apiURL + 'product/update-ringstyle',
  deleteRingStyle: apiURL + 'product/ringstyle',

  listClarity: apiURL + 'product/list-clarity',
  getClarityById: apiURL + 'product/clarity',
  addClarity: apiURL + 'product/add-clarity',
  editClarity: apiURL + 'product/update-clarity',
  deleteClarity: apiURL + 'product/clarity',

  listStoneColor: apiURL + 'product/list-stone-color',
  getStoneColorById: apiURL + 'product/stone-color',
  addStoneColor: apiURL + 'product/add-stone-color',
  editStoneColor: apiURL + 'product/update-stone-color',
  deleteStoneColor: apiURL + 'product/stone-color',

  listPearlColor: apiURL + 'product/list-pearl-color',
  getPearlColorById: apiURL + 'product/pearl-color',
  addPearlColor: apiURL + 'product/add-pearl-color',
  editPearlColor: apiURL + 'product/update-pearl-color',
  deletePearlColor: apiURL + 'product/pearl-color',

  listPearlType: apiURL + 'product/list-pearl-type',
  getPearlTypeById: apiURL + 'product/pearl-type',
  addPearlType: apiURL + 'product/add-pearl-type',
  editPearlType: apiURL + 'product/update-pearl-type',
  deletePearlType: apiURL + 'product/pearl-type',

  listDiamondColor: apiURL + 'product/list-diamond-color',
  getDiamondColorById: apiURL + 'product/diamond-color',
  addDiamondColor: apiURL + 'product/add-diamond-color',
  editDiamondColor: apiURL + 'product/update-diamond-color',
  deleteDiamondColor: apiURL + 'product/diamond-color',

  listProduct: apiURL + 'product/product-filter',
  getProductById: apiURL + 'product/product',
  addProduct: apiURL + 'product/product-create',
  editProduct: apiURL + 'product/product-update',
  deleteProduct: apiURL + 'product/product',
  getProductImagesById: apiURL + 'product/product-images',
  deleteProductImagesById: apiURL + 'product/product-images',


  listProductByVendor: apiURL + 'product/product-list',

  addToWishlist: apiURL + 'product/add-to-wishlist',
  deleteFromWishlist: apiURL + 'product/wishlist',
  getUserWishlist: apiURL + 'product/wishlist',

  getProductByFilter: apiURL + 'product/product-filter',
  updateProductStatus: apiURL + 'product/product-status',

  getNewArrivalProducts: apiURL + 'product/new-arrivals',
  getTrendingProducts: apiURL + 'product/trending',

  addProductReview: apiURL + 'product/reviews',
  getApprovedReviewsByidProduct: apiURL + 'product/reviews/approved',

  getProductCountByUser: apiURL + 'product/product-count',
  getUserWishlistCount: apiURL + 'product/wishlist-product-count',

  createChatMessage: apiURL + 'chat/send-msg',
  getMyChatHistory: apiURL + 'chat/chat-history-list',
  markMessagesSeen: apiURL + 'chat/mark-read-messages',
  getChatListUserWise: apiURL + 'chat/porduct-wise-chat-user',
  getChatListForProductOwner: apiURL + 'chat/porduct-wise-chat-userowner',
  deleteChat: apiURL + 'chat/delete-chat',


  listGoldPrices: apiURL + 'location/gold-prices',
  listSilverPrices: apiURL + 'location/silver-prices',
  listPlatinumPrices: apiURL + 'location/platinum-prices',

  getPageCmsById: apiURL + 'location/page-get',
}
